jQuery(document).ready(function($) {
    $('.aa-video-categories-list a').each(function() {
        var currentHref = $(this).attr('href'); // Get the current href
        $(this).attr('href', currentHref + '#recent'); // Append #test to the href
    });
});